function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export async function createChat() {
  const response = await fetch('/properties/chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    }
  })

  if (response.status === 429) {
    const data = await response.json()
    throw new Error(data.error)
  }
  if (!response.ok) throw new Error('Failed to create chat')

  return response.json()
}

export async function loadMessages(chatId) {
  const response = await fetch(`/properties/chat/${chatId}`, {
    headers: { 'Accept': 'application/json' }
  })
  if (!response.ok) throw new Error('Failed to load messages')
  return response.json()
}

export async function sendMessage(chatId, message, pageContext) {
  const response = await fetch(`/properties/chat/${chatId}/messages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify({ message, page_context: pageContext })
  })

  if (response.status === 429 || response.status === 422) {
    const data = await response.json()
    throw new Error(data.error)
  }
  if (!response.ok) throw new Error('Something went wrong. Please try again.')

  return response
}

export async function sendFeedback(chatId, messageId, value) {
  const response = await fetch(`/properties/chat/${chatId}/feedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify({ message_id: messageId, value })
  })
  return response.ok
}

export async function postContextNote(chatId, pageInfo) {
  const response = await fetch(`/properties/chat/${chatId}/context`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify(pageInfo)
  })

  if (response.ok && response.status !== 204) {
    return response.json()
  }
  return null
}
